// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3glmJ","col":"styles_col__f3p1W","actions":"styles_actions__Q1zf9","conflict":"styles_conflict__1utZT"};